<div class="age-gate">
    <div class="overlay"></div>

    <div class="age-modal">
        <img style="    display: inline;" src="assets/images/age-logo.png" alt="Highlife Health" class="logo" />

        <div class="divider"></div>
        <h1 id="ageTitle" class="sr-only">Age Verification</h1>
        <p class="main-text">
            {{ ageVerification?.text ? ageVerification?.text:'You must be at least 21 years old to make purchases' }}?
        </p>


        <div class="calendar-icon"><img style="width: 40px;" src="assets/images/2.png" alt="Highlife Health"
                class="img" /></div>

        <p class="sub-text">Please verify your age to continue.</p>

        <div class="actions">
            <button class="btn primary" (click)="confirmAge()"
                [attr.aria-label]="'Yes, I am at least ' + (ageVerification?.age || 21) + ' years old'">I am {{
                ageVerification?.age
                || 21 }}+</button>
            <button class="btn secondary" (click)="denyAge()" aria-label="Exit the website">Exit</button>
        </div>

        <div class="features">
            <div class="feature">
                <div class="icon"><img src="assets/images/1.png" alt="Highlife Health" class="imges" /></div>
                <p class="icons">Curated products you can trust.</p>
            </div>

            <div class="line"></div>

            <div class="feature">
                <div class="icon"><img src="assets/images/3.png" alt="Highlife Health" class="imges" /></div>
                <p class="icons">Quality you can feel,<br />wellness you can live.</p>
            </div>

            <div class="line"></div>

            <div class="feature">
                <div class="icon"><img src="assets/images/5.png" alt="Highlife Health" class="imges" /></div>
                <p class="icons">Enjoy your everyday.</p>
            </div>
        </div>

        <div class="bottom-line"></div>

        <p class="disclaimer">
            Cannabis can affect you. Please consume responsibly.
        </p>
    </div>
</div>